import { Box, Typography, Link } from '@mui/material';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { DomId } from 'constants/DomId';

// TODO internationalize if we end up caring about it

const HelpAdvancedSearch = () => {
  return (
    <Box>
      <Typography variant='body1'>
        There are a variety of ways to search. If you aren't familiar with the
        basics, you may first want to look at{' '}
        <Link component={RouterLink} to={`#${DomId.HelpImages}`}>
          the general search advice.
        </Link>
      </Typography>
      <br />

      <Typography variant='body1'>
        The search field offers many advanced options. A few will be listed
        here, but this is not a fully inclusive list; if you have worked with
        advanced searches before, many of the same techniques you know should
        also work here.
      </Typography>
      <ul>
        <li>Wildcard Searches</li>
        <ul>
          <li>
            Say you want to search for a UPC family, all UPCs that begin with a
            certain combination of characters. 00670433015089 could be the UPC
            you want to search for the family of, you would instead search for
            '0067043301*', this will return all UPCs that begin with that set of
            characters.
          </li>
        </ul>
        <li>Explicit Searches</li>
        <ul>
          <li>
            If your search term is something like 'chicken soup' (no quotes),
            your result set may contain both chicken and soup. If, however, you
            just wanted chicken soup, you could search for '"chicken soup"'
            (with quotes), or for 'chicken +soup'
          </li>
          <li>
            In a similar scenario, say you wanted chicken results, but you
            didn't want chicken soup results, you could search for 'chicken
            -soup'
          </li>
        </ul>
      </ul>
    </Box>
  );
};

export default HelpAdvancedSearch;
